import React from 'react';
import { CardBox } from 'components';
// import { termsAndConditionsParagraphs, termsAndConditionsTitle } from "./constants";

export const TermsAndConditionsFragment = () => {
    return (
        <div className="terms-and-conditions-fragment open-sans">
            <CardBox cardBackgroundColor={'#FFFFFF'}>
                <div className="terms-and-conditions-container">
                    <h3 className="content-title">Terms of Use</h3>
                    <div className="terms-and-conditions-content">
                        <div className="container">
                            <header>
                                <p>
                                    <strong>Effective Date:</strong> 07/24/2025
                                </p>
                                {/*<div className="meta">Effective Date: <strong>07/24/2025</strong></div>*/}
                                <p>
                                    This Terms of Use agreement (“Agreement”) is entered into between you (“you,” “your,” or “User”) and
                                    <strong> THERAPYLAKE, LLC</strong> (“TherapyLake,” “we,” “our,” or “us”). This Agreement governs your
                                    use of our website and any associated online services (collectively, the “Website”) unless you are
                                    covered under a separate written agreement such as a Master Services Agreement between your organization
                                    and TherapyLake.
                                </p>
                                <p>
                                    <strong>PLEASE READ THESE TERMS CAREFULLY.</strong> By accessing or using the Website, you confirm that
                                    you understand and agree to be legally bound by this Agreement. If you are using the Website on behalf
                                    of an organization, you represent that you have the authority to bind that entity to these Terms. If you
                                    do not agree or lack such authority, you must not use the Website.
                                </p>
                                <p>
                                    TherapyLake may revise this Agreement at any time at its sole discretion. When changes are made, we will
                                    update the “Effective Date” and may notify you of material changes by updating the
                                    <a href="https://therapylake.com/terms-and-conditions" target="_blank" rel="noopener noreferrer">
                                        https://therapylake.com/terms-and-conditions
                                    </a>
                                    web page. Your continued use of the Website following such modifications constitutes acceptance of the
                                    revised terms.
                                </p>
                                <p>
                                    Your use of the Website is also governed by our
                                    <a href="https://therapylake.com/privacy-policy" target="_blank" rel="noopener noreferrer">
                                        Privacy Policy
                                    </a>
                                    , which outlines how we collect and handle personal information. By using the Website, you agree to that
                                    Privacy Policy, which is incorporated into these Terms by reference.
                                </p>
                            </header>

                            <main>
                                <section id="definitions">
                                    <h2>
                                        <span className="section-number">2.</span>Definitions
                                    </h2>
                                    <p>For purposes of this Agreement, capitalized terms have the following meanings:</p>
                                    <ul>
                                        <li>
                                            <strong>Customer</strong> means the legal entity or organization that has entered into a
                                            subscription order or agreement with TherapyLake to access our software and services.
                                        </li>
                                        <li>
                                            <strong>Documentation</strong> refers to any user guides, reference materials, specifications,
                                            or instructional content provided or made available by TherapyLake to support use of the
                                            Services.
                                        </li>
                                        <li>
                                            <strong>Effective Date</strong> means the earlier of the date you (a) accept this Agreement or
                                            (b) first access or use the Services.
                                        </li>
                                        <li>
                                            <strong>Privacy Policy</strong> means our privacy policy available at{' '}
                                            <a href="https://www.therapylake.com/privacy" target="_blank" rel="noopener noreferrer">
                                                www.therapylake.com/privacy
                                            </a>
                                            , which is hereby incorporated by reference.
                                        </li>
                                        <li>
                                            <strong>Services</strong> refers to TherapyLake’s proprietary software platform and related
                                            services offered through the Website, excluding any third-party tools or content not developed
                                            or owned by TherapyLake.
                                        </li>
                                        <li>
                                            <strong>Third-Party Products</strong> means any content, software, or technology provided by a
                                            third party that is not owned or developed by TherapyLake, even if accessed through or in
                                            conjunction with the Services.
                                        </li>
                                        <li>
                                            <strong>User</strong> means any individual authorized by a Customer to use the Services,
                                            including staff members, contractors, consultants, care providers, administrators, parents, or
                                            agents acting on behalf of the Customer.
                                        </li>
                                        <li>
                                            <strong>User Data</strong> refers to all data, files, inputs, or other content submitted or
                                            transmitted by a User through the Services. This excludes anonymized data or aggregate insights
                                            generated by TherapyLake in a way that does not identify individuals (“Anonymized Data”).
                                        </li>
                                    </ul>
                                </section>

                                <section id="use-of-services">
                                    <h2>
                                        <span className="section-number">3.</span>Use of Services
                                    </h2>

                                    <h3>3.1. Limited License</h3>
                                    <p>
                                        Subject to the terms of this Agreement, TherapyLake grants you a limited, non-exclusive,
                                        non-transferable, and non-sublicensable license to access and use the Services solely for the
                                        internal business purposes of the Customer and in accordance with applicable Documentation and any
                                        subscription order terms. This license does not grant any rights to the underlying software code or
                                        intellectual property beyond what is expressly permitted.
                                    </p>

                                    <h3>3.2. Support</h3>
                                    <p>
                                        TherapyLake provides support for the Services during standard business hours (Monday to Friday, 9:00
                                        AM to 5:00 PM Pacific Time) in accordance with our current Service Level Terms available at
                                        <a href="https://www.therapylake.com/legal/sla" target="_blank" rel="noopener noreferrer">
                                            www.therapylake.com/legal/sla
                                        </a>
                                        , which may be updated periodically.
                                    </p>

                                    <h3>3.3. Account Responsibility</h3>
                                    <p>
                                        You are responsible for maintaining the confidentiality of your account credentials. You agree to
                                        promptly notify TherapyLake if you become aware of any unauthorized access to your account. You are
                                        solely responsible for all activity occurring under your account.
                                    </p>

                                    <h3>3.4. Acceptable Use</h3>
                                    <p>You agree not to, and will not permit others to:</p>
                                    <ul>
                                        <li>Modify, adapt, or create derivative works based on the Services.</li>
                                        <li>
                                            Reverse engineer, decompile, or otherwise attempt to access the source code or system
                                            architecture of the Services.
                                        </li>
                                        <li>Use the Services to develop competing products or services.</li>
                                        <li>Share, resell, lease, or sublicense the Services to third parties.</li>
                                        <li>Use automated tools (e.g., bots, scrapers) to extract or download data from the Services.</li>
                                        <li>
                                            Use the Services to transmit or upload unlawful, obscene, defamatory, or infringing content.
                                        </li>
                                        <li>Impersonate others or misrepresent your identity or affiliation.</li>
                                        <li>
                                            Access the Services in violation of applicable laws or regulations, including data privacy laws.
                                        </li>
                                    </ul>
                                    <p>
                                        TherapyLake reserves the right to suspend or terminate access to the Services if we determine, at
                                        our sole discretion, that you or any authorized User is in violation of this Section.
                                    </p>
                                </section>

                                <section id="intellectual-property">
                                    <h2>
                                        <span className="section-number">4.</span>Intellectual Property
                                    </h2>

                                    <h3>4.1. Ownership of Services</h3>
                                    <p>
                                        TherapyLake and its licensors retain all right, title, and interest in and to the Services, the
                                        Documentation, and all underlying software, technology, algorithms, and related content. This
                                        Agreement does not transfer or assign any ownership rights to you or any third party. All rights not
                                        expressly granted to you are reserved by TherapyLake.
                                    </p>

                                    <h3>4.2. Anonymized Data</h3>
                                    <p>
                                        TherapyLake may collect and use aggregated or de-identified data derived from your use of the
                                        Services for purposes such as improving our platform, analytics, and machine learning development.
                                        Such data will not identify any individual and will not contain Protected Health Information (PHI)
                                        unless appropriately de-identified in accordance with HIPAA. You hereby assign any rights you may
                                        have in such anonymized data to TherapyLake.
                                    </p>

                                    <h3>4.3. Third-Party Components</h3>
                                    <p>
                                        The Services may incorporate or interoperate with software, tools, or other assets provided by third
                                        parties ("Third-Party Components"). Ownership and licensing terms for such components are governed
                                        by their respective providers and may be subject to separate license terms. Nothing in this
                                        Agreement grants you rights in any Third-Party Components beyond those permitted under applicable
                                        third-party licenses.
                                    </p>

                                    <h3>4.4. Open Source Software</h3>
                                    <p>
                                        Certain parts of the Services may include open-source software distributed under open-source
                                        licenses. Your rights to use such open-source components are governed by the terms of those
                                        licenses. Nothing in this Agreement is intended to limit your rights under those licenses, but you
                                        agree that use of open-source components within the context of the Services shall not conflict with
                                        the terms set by TherapyLake.
                                    </p>

                                    <h3>4.5. Feedback</h3>
                                    <p>
                                        If you submit feedback, suggestions, or ideas about the Services to TherapyLake, you agree that we
                                        may freely use such feedback without restriction or compensation to you. You assign to TherapyLake
                                        all rights, title, and interest in any feedback provided.
                                    </p>
                                </section>

                                <section id="representations-warranties">
                                    <h2>
                                        <span className="section-number">5.</span>Representations and Warranties
                                    </h2>

                                    <h3>5.1. Mutual Representations</h3>
                                    <p>Each party represents and warrants that:</p>
                                    <ul>
                                        <li>It has full authority to enter into this Agreement and to perform its obligations under it;</li>
                                        <li>This Agreement is a binding and enforceable legal obligation;</li>
                                        <li>
                                            It will comply with all applicable laws, regulations, and industry standards in connection with
                                            its performance under this Agreement, including but not limited to those related to data
                                            protection and patient privacy (e.g., HIPAA, where applicable);
                                        </li>
                                        <li>
                                            The execution and performance of this Agreement do not conflict with or breach any other
                                            agreement to which the party is bound.
                                        </li>
                                    </ul>

                                    <h3>5.2. Your Additional Representations</h3>
                                    <p>You further represent and warrant that:</p>
                                    <ul>
                                        <li>
                                            You have all rights, licenses, and consents necessary to provide any User Data (including any
                                            Protected Health Information), and to grant TherapyLake the rights to process that data under
                                            this Agreement;
                                        </li>
                                        <li>
                                            Any User Data submitted through the Services will not violate the rights of any third party,
                                            including but not limited to intellectual property rights, privacy rights, or contractual
                                            rights;
                                        </li>
                                        <li>
                                            User Data does not and will not include any unlawful, harmful, defamatory, or obscene content;
                                        </li>
                                        <li>
                                            You are solely responsible for the accuracy, quality, and legality of the User Data you upload
                                            or transmit through the Services;
                                        </li>
                                        <li>
                                            If you use SMS, email, or other communication features of the Services, you will obtain any
                                            legally required consents from message recipients, and your use will comply with applicable
                                            telecommunications and privacy laws.
                                        </li>
                                    </ul>
                                </section>

                                <section id="disclaimer-liability">
                                    <h2>
                                        <span className="section-number">6.</span>Disclaimer and Limitation of Liability
                                    </h2>

                                    <h3>6.1. General Disclaimer</h3>
                                    <p>
                                        EXCEPT AS EXPRESSLY STATED IN THIS AGREEMENT, THE SERVICES AND ALL RELATED MATERIALS ARE PROVIDED
                                        “AS IS” AND “AS AVAILABLE,” WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. THERAPYLAKE
                                        DISCLAIMS ALL WARRANTIES, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY,
                                        FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, AND TITLE.
                                    </p>
                                    <p>
                                        WE DO NOT GUARANTEE THAT THE SERVICES WILL BE UNINTERRUPTED, SECURE, ERROR-FREE, OR FREE FROM
                                        VIRUSES OR OTHER HARMFUL COMPONENTS. YOU ARE RESPONSIBLE FOR IMPLEMENTING SUFFICIENT PROCEDURES TO
                                        SATISFY YOUR PARTICULAR REQUIREMENTS FOR DATA BACKUP AND SECURITY.
                                    </p>

                                    <h3>6.2. No Medical or Legal Advice</h3>
                                    <p>
                                        YOU UNDERSTAND AND AGREE THAT THERAPYLAKE IS NOT ENGAGED IN THE PRACTICE OF MEDICINE OR PROVIDING
                                        MEDICAL, LEGAL, OR OTHER PROFESSIONAL ADVICE. THE SERVICES ARE NOT A SUBSTITUTE FOR CLINICAL
                                        JUDGMENT OR PROFESSIONAL DIAGNOSIS, TREATMENT, OR DECISION-MAKING. IT IS YOUR RESPONSIBILITY TO
                                        VERIFY THE ACCURACY OF ANY INFORMATION YOU ENTER INTO OR RECEIVE THROUGH THE SERVICES AND TO COMPLY
                                        WITH ALL PROFESSIONAL STANDARDS AND REGULATORY REQUIREMENTS.
                                    </p>

                                    <h3>6.3. Limitation of Liability</h3>
                                    <p>
                                        TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THERAPYLAKE AND ITS AFFILIATES, SUPPLIERS, AND
                                        LICENSORS SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
                                        DAMAGES, INCLUDING BUT NOT LIMITED TO LOST PROFITS, LOST REVENUE, LOSS OF DATA, BUSINESS
                                        INTERRUPTION, OR PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES, HOWEVER CAUSED AND UNDER ANY THEORY OF
                                        LIABILITY—EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
                                    </p>
                                    <p>
                                        THERAPYLAKE’S TOTAL LIABILITY FOR ANY CLAIMS ARISING OUT OF OR RELATED TO THIS AGREEMENT OR YOUR USE
                                        OF THE SERVICES SHALL NOT EXCEED ONE HUNDRED DOLLARS ($100), REGARDLESS OF THE NATURE OF THE CLAIM.
                                    </p>
                                </section>

                                <section id="privacy-security">
                                    <h2>
                                        <span className="section-number">7.</span>Privacy and Data Security
                                    </h2>

                                    <h3>7.1. Data Security</h3>
                                    <p>
                                        TherapyLake maintains administrative, physical, and technical safeguards reasonably designed to
                                        protect the confidentiality, integrity, and availability of Personal Information and any Protected
                                        Health Information (“PHI”) you may submit through the Services. We regularly review and update our
                                        security protocols and conduct risk assessments to address emerging threats and vulnerabilities. You
                                        acknowledge that no security measures are foolproof and that TherapyLake cannot guarantee absolute
                                        security.
                                    </p>
                                    <p>
                                        In the event of a confirmed security breach that involves your PHI, TherapyLake will notify you
                                        without undue delay, in accordance with applicable law and regulatory requirements.
                                    </p>

                                    <h3>7.2. HIPAA Compliance</h3>
                                    <p>
                                        Where applicable, TherapyLake will comply with the Health Insurance Portability and Accountability
                                        Act of 1996, as amended (“HIPAA”), the Health Information Technology for Economic and Clinical
                                        Health Act (“HITECH”), and any implementing regulations to the extent required by our role as a
                                        Business Associate. TherapyLake will process PHI solely in accordance with applicable law, your
                                        documented instructions, and the terms set forth in our Business Associate Agreement, which is
                                        incorporated by reference and available at{' '}
                                        <a href="https://therapylake.com/legal/hipaa" target="_blank" rel="noopener noreferrer">
                                            therapylake.com/legal/hipaa
                                        </a>{' '}
                                        (or such updated URL as may be provided).
                                    </p>

                                    <h3>7.3. Privacy Laws</h3>
                                    <p>
                                        TherapyLake may act as a “Service Provider” or “Processor” under state consumer privacy laws such as
                                        the California Privacy Rights Act (“CPRA”), the Virginia Consumer Data Protection Act (“VCDPA”), and
                                        similar U.S. laws (collectively, “Privacy Laws”), to the extent applicable. You represent that any
                                        Personal Information you provide to TherapyLake was collected in compliance with these laws, and
                                        that you have the right to share such data with us.
                                    </p>
                                    <p>
                                        TherapyLake will not retain, use, disclose, or share Personal Information for any purpose other than
                                        to fulfill our obligations under this Agreement, or as otherwise permitted by law.
                                    </p>

                                    <h3>7.4. Subprocessors</h3>
                                    <p>
                                        TherapyLake may engage third-party vendors or affiliates (“Subprocessors”) to help operate or
                                        support the Services. Subprocessors will be bound by contractual obligations no less protective than
                                        those set forth in this Agreement. A list of current Subprocessors is available upon request.
                                    </p>
                                </section>

                                <section id="indemnification">
                                    <h2>
                                        <span className="section-number">8.</span>Indemnification
                                    </h2>

                                    <h3>8.1. Indemnification by You</h3>
                                    <p>
                                        You agree to indemnify, defend, and hold harmless TherapyLake, its officers, directors, employees,
                                        agents, affiliates, licensors, and service providers from and against any and all claims, damages,
                                        obligations, losses, liabilities, costs, or debt, and expenses (including but not limited to
                                        reasonable attorneys’ fees) arising from or related to:
                                    </p>
                                    <ol>
                                        <li>Your violation of any term of this Agreement;</li>
                                        <li>Your misuse of the Services;</li>
                                        <li>
                                            Your violation of any applicable law or regulation, including without limitation HIPAA or other
                                            data protection laws;
                                        </li>
                                        <li>
                                            Your User Data, including but not limited to any claim that the User Data infringes the
                                            intellectual property rights or privacy rights of a third party;
                                        </li>
                                        <li>Any breach of your obligations regarding PHI or Personal Information.</li>
                                    </ol>

                                    <h3>8.2. Indemnification Procedure</h3>
                                    <p>
                                        TherapyLake will promptly notify you in writing of any claim for which it seeks indemnification.
                                        Failure to provide timely notice shall not relieve you of your indemnification obligations, except
                                        to the extent such failure materially prejudices your defense. TherapyLake reserves the right to
                                        participate in the defense of any claim with its own counsel, at its own expense. You shall not
                                        settle any claim without TherapyLake’s prior written consent if such settlement imposes any
                                        liability or obligation on TherapyLake.
                                    </p>
                                </section>

                                <section id="term-termination">
                                    <h2>
                                        <span className="section-number">9.</span>Term and Termination
                                    </h2>

                                    <h3>9.1. Term</h3>
                                    <p>
                                        This Agreement becomes effective on the earlier of (a) the date you accept the Terms, or (b) the
                                        date you first access or use the Services (“Effective Date”), and will continue in effect until
                                        terminated as provided below.
                                    </p>

                                    <h3>9.2. Termination for Cause</h3>
                                    <p>
                                        Either party may terminate this Agreement with immediate effect upon written notice if the other
                                        party:
                                    </p>
                                    <ul>
                                        <li>
                                            (a) Materially breaches this Agreement and fails to cure such breach within thirty (30) days of
                                            receiving written notice;
                                        </li>
                                        <li>
                                            (b) Becomes the subject of a petition in bankruptcy or other proceeding relating to insolvency,
                                            receivership, liquidation, or assignment for the benefit of creditors.
                                        </li>
                                    </ul>

                                    <h3>9.3. Termination for Convenience</h3>
                                    <p>
                                        TherapyLake may suspend or terminate your access to all or any part of the Services at any time,
                                        with or without cause, by providing you with written notice. You may discontinue use of the Services
                                        at any time, but you will remain liable for any outstanding fees or obligations that accrued before
                                        termination.
                                    </p>

                                    <h3>9.4. Effect of Termination</h3>
                                    <p>Upon termination of this Agreement:</p>
                                    <ol>
                                        <li>All licenses granted hereunder shall immediately terminate;</li>
                                        <li>You shall cease all use of the Services;</li>
                                        <li>
                                            Sections that by their nature should survive termination (including Sections 3–5, 6.2, 6.3,
                                            7–12) shall remain in effect.
                                        </li>
                                    </ol>
                                </section>

                                <section id="governing-law">
                                    <h2>
                                        <span className="section-number">10.</span>Governing Law and Venue
                                    </h2>
                                    <p>
                                        This Agreement and any dispute arising out of or relating to it shall be governed by and construed
                                        in accordance with the laws of the State of California, without regard to its conflict of law
                                        principles.
                                    </p>
                                    <p>
                                        You and TherapyLake agree that any legal action or proceeding relating to this Agreement shall be
                                        brought exclusively in the state or federal courts located in Los Angeles County, California. Each
                                        party consents to the personal jurisdiction of such courts and waives any objection based on
                                        improper venue or forum non conveniens.
                                    </p>
                                    <p>
                                        The United Nations Convention on Contracts for the International Sale of Goods does not apply to
                                        this Agreement.
                                    </p>
                                </section>

                                <section id="miscellaneous">
                                    <h2>
                                        <span className="section-number">11.</span>Miscellaneous
                                    </h2>

                                    <h3>Independent Contractors</h3>
                                    <p>
                                        The parties are independent contractors. Nothing in this Agreement creates a partnership, joint
                                        venture, employment, or agency relationship between TherapyLake and you. Neither party is authorized
                                        to bind the other to any obligation or agreement.
                                    </p>

                                    <h3>Entire Agreement</h3>
                                    <p>
                                        This Terms of Use, along with any applicable service agreement or order form entered into between
                                        you and TherapyLake, constitutes the entire agreement between the parties concerning your access to
                                        and use of the Services and supersedes all prior or contemporaneous communications and proposals,
                                        whether oral or written.
                                    </p>

                                    <h3>Assignment</h3>
                                    <p>
                                        You may not assign or transfer this Agreement, by operation of law or otherwise, without prior
                                        written consent from TherapyLake. Any attempt by you to assign or transfer this Agreement without
                                        such consent will be null and void. TherapyLake may assign or transfer this Agreement without
                                        restriction, including in connection with a merger, acquisition, or sale of assets.
                                    </p>

                                    <h3>Force Majeure</h3>
                                    <p>
                                        Neither party shall be liable for failure or delay in performing its obligations under this
                                        Agreement if such failure or delay is due to circumstances beyond its reasonable control, including
                                        but not limited to natural disasters, acts of government, labor disputes, power failures, internet
                                        outages, or telecommunications failures.
                                    </p>

                                    <h3>Export Compliance</h3>
                                    <p>
                                        The Services may be subject to U.S. export control laws and regulations. You agree to comply with
                                        all such laws and regulations and will not use or export the Services in violation of any applicable
                                        laws.
                                    </p>

                                    <h3>Notice</h3>
                                    <p>Any legal notices required under this Agreement shall be given:</p>
                                    <p>
                                        <strong>To TherapyLake</strong>
                                        <br />
                                        via email at <a href="mailto:info@therapylake.com">info@therapylake.com</a> and via mail to:
                                        <br />
                                        TherapyLake
                                        <br />
                                        4100 W Alameda Ave, 3rd floor
                                        <br />
                                        Burbank, CA 91505
                                    </p>
                                    <p>
                                        To you, via the email or mailing address associated with your account, or by posting a notice within
                                        the Services.
                                    </p>

                                    <h3>No Third-Party Beneficiaries</h3>
                                    <p>
                                        This Agreement is intended solely for the benefit of the parties and their permitted assigns, and
                                        does not confer any rights or remedies on any third party.
                                    </p>
                                </section>
                            </main>

                            <footer>
                                <p>
                                    If you have questions about these Terms, please contact us at{' '}
                                    <a href="mailto:info@therapylake.com">info@therapylake.com</a>.
                                </p>
                            </footer>
                        </div>

                        {/*{termsAndConditionsParagraphs.map((paragraph, index) => (*/}
                        {/*    <p key={index} className="terms-and-conditions-paragraph">*/}
                        {/*        {paragraph}*/}
                        {/*    </p>*/}
                        {/*))}*/}
                    </div>
                </div>
            </CardBox>
        </div>
    );
};
